import { useQuery } from '@apollo/client';
import { GET_USERS } from './query';
export function useGetUsers() {
    const { data, loading, error } = useQuery(GET_USERS);
    const isNonNullableUser = (user) => Boolean(user);
    const companyUsers = (data === null || data === void 0 ? void 0 : data.companyUsers) || [];
    const users = companyUsers.map(({ user }) => user).filter(isNonNullableUser);
    return { users, loading, error };
}
